import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const TopicHomepage: LoadableType<{
	topicId: string;
}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-TopicHomepageComponent" */ './TopicHomepageComponent.tsx'
			)
		).TopicHomepageComponent,
});
